var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSpecified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4443 7.6853C12.0888 6.58649 14.0222 6 16 6C18.6522 6 21.1957 7.05357 23.0711 8.92893C24.9464 10.8043 26 13.3478 26 16C26 17.9778 25.4135 19.9112 24.3147 21.5557C23.2159 23.2002 21.6541 24.4819 19.8268 25.2388C17.9996 25.9957 15.9889 26.1937 14.0491 25.8078C12.1093 25.422 10.3275 24.4696 8.92894 23.0711C7.53041 21.6725 6.578 19.8907 6.19215 17.9509C5.8063 16.0111 6.00433 14.0004 6.76121 12.1732C7.51809 10.3459 8.79981 8.78412 10.4443 7.6853ZM9.69 11.1C8.5985 12.5005 8.00394 14.2244 8 16C8.00257 17.4952 8.42412 18.9598 9.21683 20.2276C10.0095 21.4953 11.1417 22.5156 12.4848 23.1726C13.8279 23.8296 15.3283 24.097 16.8157 23.9445C18.3032 23.7921 19.7181 23.2258 20.9 22.31L22.31 20.9C23.4806 19.3598 24.0534 17.4477 23.9225 15.5176C23.7915 13.5875 22.9656 11.7702 21.5977 10.4023C20.2298 9.03441 18.4125 8.2085 16.4824 8.07754C14.5523 7.94657 12.6402 8.51941 11.1 9.69L9.69 11.1Z",
    fill: "#748398"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0016 17.3969C16.0016 16.5969 16.0016 16.1969 16.8016 15.7969C17.6016 15.3969 18.4016 14.9969 18.4016 13.7969C18.4016 12.9969 17.6016 11.7969 16.0016 11.7969C14.4016 11.7969 13.6016 12.8081 13.6016 14.1969M16.0016 20.1969V20.192",
    stroke: "#748398",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSpecified);
export default __webpack_public_path__ + "static/media/not_specified.cd98acf3e92532ec622c90277b1b8b85.svg";
export { ForwardRef as ReactComponent };